import styled from '@emotion/styled';

export const StyledHelpText = styled.div(({ theme }) => ({
	fontSize: theme.fontSizes['2xs'],
	lineHeight: 1.25,
	color: theme.colors.grey60,
	marginTop: 8,
}));
